import { RenewalYearsResolver } from './resolvers/renewal-years.resolver';

export { RenewalYearsResolver } from './resolvers/renewal-years.resolver';

export const RESOLVERS: any[] = [
	RenewalYearsResolver
];
